<template>
  <StModal size="medium" :on-close="() => emit(CLOSE)">
    <div class="st-add-offer-confirmation-modal">
      <StHeadline :level="2">Lägg till {{ offerName }}</StHeadline>
      <p>
        Är du säker på att du vill lägga till {{ offerName }} för
        {{ organizationNumber }}?
      </p>
      <div class="st-add-offer-confirmation-modal__buttons">
        <StButton
          rectangular
          secondary
          full-width
          type="button"
          @click="emit(CLOSE)"
        >
          Avbryt
        </StButton>
        <StButton
          rectangular
          full-width
          type="button"
          :is-loading="isLoading"
          @click="emit('add')"
        >
          Lägg till
        </StButton>
      </div>
      <StError v-if="errorMessage" :error-message="errorMessage" />
    </div>
  </StModal>
</template>

<script setup>
import { StButton, StError, StHeadline, StModal } from "skanetrafiken";
import { CLOSE } from "@/constants";

const emit = defineEmits(["add", "close"]);

defineProps({
  offerName: String,
  organizationNumber: String,
  isLoading: Boolean,
  errorMessage: String,
});
</script>

<style scoped lang="scss">
@import "~skanetrafiken/dist/scss/main.scss";

.st-add-offer-confirmation-modal {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: rem-calc(16);

  p {
    margin: rem-calc(8) 0 rem-calc(16);
  }

  &__buttons {
    display: flex;
    gap: rem-calc(16);
  }
}
</style>
